<template>
  <div>
    <Row type="flex" justify="center">
      <Col>
        <h3
          style="color:#893448;font-size:18px;letter-spacing:0.4px;white-space: nowrap;"
        >{{ table_title }}</h3>
      </Col>
    </Row>
    <Row style="height:15px;"></Row>
    <Row>
      <v-table
        :title="this.control_str_human_show_record_title"
        :title_info="this.control_str_human_show_record_info"
        :table_columns="this.control_str_human_show_record_table_columns"
        :table_data="this.control_str_human_show_record_table_data"
        :table_ref="this.control_str_human_show_record_ref"
        :max_height="1000"
        :init_table="this.control_str_human_show_record_init_table_func"
        :table_name_array="this.control_str_human_show_name_array"
        :show_top="false"
        :show_page="true"
        :table_page_size="50"
      ></v-table>
      <Modal
        v-model="control_str_human_set_modal"
        :title="this.get_modal_title()"
        loading
        @on-ok="control_str_human_set_ok"
        @on-cancel="control_str_human_set_cancel"
      >
        <p slot="header" class="demo-drawer-hearde">
          <Icon type="information-circled"></Icon>
          <span>{{ this.get_modal_title() }}</span>
        </p>
        <Row>
          <Col span="20" offset="2">
          <div v-if="this.control_str_human_set_mode === 1">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="调整buy方向比例">
                  <Slider
                    v-model="control_str_human_set_msg['buy_rate']"
                    :step="0.01"
                    :max="1"
                    :min="0"
                    show-input
                  ></Slider>
              </FormItem>
              <FormItem label="调整sell方向比例">
                  <Slider
                    v-model="control_str_human_set_msg['sell_rate']"
                    :step="0.01"
                    :max="1"
                    :min="0"
                    show-input
                  ></Slider>
              </FormItem>
              <FormItem label="黏连机制开关">
                  <i-switch
                    v-model="control_str_human_set_msg['switch']"
                    size="large"
                    true-color="#13ce66" 
                    false-color="#ff4949"
                    :false-value='0'
                    :true-value='1'
                  >
                  <span slot="open">打开</span>
                  <span slot="close">关闭</span>
                  </i-switch>
              </FormItem>
              <FormItem label="人工介入止盈">
                  <i-switch
                    v-model="control_str_human_set_msg['stop_gain_switch']"
                    size="large"
                    true-color="#13ce66" 
                    false-color="#ff4949"
                    :false-value='0'
                    :true-value='1'
                  >
                  <span slot="open">打开</span>
                  <span slot="close">关闭</span>
                  </i-switch>
              </FormItem>
              <FormItem label="调整止盈百分比">
                  <Slider
                    v-model="control_str_human_set_msg['stop_gain_percent']"
                    :step="0.0001"
                    :max="0.3"
                    :min="0.0001"
                    show-input
                  ></Slider>
              </FormItem>
              <FormItem label="人工介入止损">
                  <i-switch
                    v-model="control_str_human_set_msg['stop_loss_switch']"
                    size="large"
                    true-color="#13ce66" 
                    false-color="#ff4949"
                    :false-value='0'
                    :true-value='1'
                  >
                  <span slot="open">打开</span>
                  <span slot="close">关闭</span>
                  </i-switch>
              </FormItem>
              <FormItem label="调整止损百分比">
                  <Slider
                    v-model="control_str_human_set_msg['stop_loss_percent']"
                    :step="0.0001"
                    :max="0.1"
                    :min="0.0001"
                    show-input
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.control_str_human_set_mode === 2">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="调整guppy当前仓位">
                  <Slider
                    v-model="control_str_human_set_msg['position_human']"
                    :step="0.01"
                    :max="1"
                    :min="0"
                    show-input
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          </Col>
        </Row>
      </Modal>
    </Row>
  </div>
</template>


<script>
import table_view from "../components/TableView.vue";
import render_table_view from '../components/tableRender.vue';
export default {
  name: "tools_control_strategy_human",
  components: {
    "v-table": table_view,
  },
  data() {
    return {
      control_str_human_set_str_id:null,
      control_str_human_set_modal:false,
      control_str_human_set_msg:{},
      control_str_human_set_mode:0,
      table_title: "运行策略状态",
      control_str_human_show_record_title: "",
      control_str_human_show_record_info: [],
      control_str_human_show_record_table_columns: [],
      control_str_human_show_record_table_data: [],
      control_str_human_show_record_ref: "control_str_human_record_ref",
      control_str_human_show_name_array: [
        "策略编号",
        "策略描述",
        "策略参数",
        "控制接口",
        "控制接口信息",
        "涉及到的账户一览"
      ],
      timer: null,
    };
  },
  methods: {
    draw_table_control_str_human: async function() {
      let data = await this.$axios.get(
          this.$store.state.urlPort + "/control_strategy_human",
          {
            params: {
              mode: "get_set_table_msg",
            }
          }
        )
      this.control_str_human_show_record_table_data = data["data"]
    },
    get_modal_title: function () {
      return this.control_str_human_set_str_id + "号策略";
    },
    control_str_human_set_cancel: function () {
      this.control_str_human_set_modal = false
    },
    control_str_human_set_ok: async function () {
      let formData = new FormData();
      formData = new FormData();
      formData.append("data",JSON.stringify(this.control_str_human_set_msg));
      formData.append("strategy_id", this.control_str_human_set_str_id);
      formData.append("strategy_mode", this.control_str_human_set_mode);
      formData.append("mode", "change_strategy_interface");
      var res = await this.$axios({
        url: this.$store.state.urlPort + "/control_strategy_human",
        method: "post",
        data: formData,
      });
      this.$Message.success(res)
      setTimeout(() => {
        this.control_str_human_set_modal = false
        this.draw_table_control_str_human()
      }, 2000);
      
    },
    control_str_human_show_record_init_table_func: function() {
      const name_array = this.control_str_human_show_name_array;
      this.control_str_human_show_record_table_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        if (i==3) {
          //越过控制接口，不显示再表格中
          continue
        }
        this.control_str_human_show_record_table_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      this.control_str_human_show_record_table_columns[0]["width"] = 100;
      this.control_str_human_show_record_table_columns[1]["minwidth"] = 205;
      this.control_str_human_show_record_table_columns[2]["minwidth"] = 205;
      this.control_str_human_show_record_table_columns[2]["tooltip"] = true;
      // this.control_str_human_show_record_table_columns[3]["width"] = 100;
      // this.control_str_human_show_record_table_columns[3]["render"] = (h,params) => {
      //   return h("div", [
      //     this.$createElement(
      //       "Button",
      //       {
      //         props: {
      //           loading: false,
      //         },
      //         style: {
      //           border: "hidden",
      //           "font-size": "12px",
      //           background: "transparent",
      //         },
      //         on: {
      //           click: () => {
                  
      //           },
      //         },
      //       },
      //       "修改"
      //     ),
      //   ]);
      // };
      this.control_str_human_show_record_table_columns[3]["minwidth"] = 350;
      this.control_str_human_show_record_table_columns[3]["render"] = (h,params) => {
        var value = params["row"]["控制接口信息"];
        var control_str_human_set_mode = params["row"]["控制接口"]
        if (control_str_human_set_mode == 1) {
          var color_1, color_2, color_3, color_4, color_5
          if (value[0] == 1) {color_1 = "#00CC00"} else {color_1 = "#996600"}
          if (value[1] == 1) {color_2 = "#00CC00"} else {color_2 = "#996600"}
          if (value[2] == "开启黏连") {color_3 = "#00CC00"} else {color_3 = "#996600"}
          if (value[3] == "不介入止盈") {color_4 = "#00CC00"} else {color_4 = "#996600"}
          if (value[5] == "不介入止损") {color_5 = "#00CC00"} else {color_5 = "#996600"}
          return h("div", [
            h(render_table_view,{
                props: {
                  columns: [
                    {"title":"buy方向可开比例", "data":100.0*value[0]+"%", "color":color_1},
                    {"title":"sell方向可开比例", "data":100.0*value[1]+"%", "color":color_2},
                    {"title":"黏连机制开关", "data":value[2], "color":color_3},
                    {"title":"止盈百分比", "data":parseFloat((100.0*value[4]).toFixed(2))+"%", "color":color_4},
                    {"title":"止损百分比", "data":parseFloat((100.0*value[6]).toFixed(2))+"%", "color":color_5},
                  ],
                },
                on:{
                  myclick:() => {
                    this.control_str_human_set_str_id = params["row"]["策略编号"];
                    this.control_str_human_set_mode = params["row"]["控制接口"];
                    var tmp = params["row"]["控制接口信息"];
                    this.control_str_human_set_msg = {
                      'buy_rate':tmp[0],
                      'sell_rate':tmp[1],
                      'switch':(tmp[2] === "关闭黏连")?0:1,
                      'stop_gain_switch':(tmp[3] === "不介入止盈")?0:1,
                      'stop_gain_percent':tmp[4],
                      'stop_loss_switch':(tmp[5] === "不介入止损")?0:1,
                      'stop_loss_percent':tmp[6],
                    }
                    this.control_str_human_set_modal = true;
                  }
                }
              },
            )
          ]);
        } else if (control_str_human_set_mode == 2) {
          var color_1
          if (value[0] == 1) {color_1 = "#00CC00"} else {color_1 = "#996600"}
          return h("div", [
            h(render_table_view,{
                props: {
                  columns: [{"title":"guppy开仓头寸", "data":100*value[0]+"%", "color":color_1}],
                },
                on:{
                  myclick:() => {
                    this.control_str_human_set_str_id = params["row"]["策略编号"];
                    this.control_str_human_set_mode = params["row"]["控制接口"];
                    var tmp = params["row"]["控制接口信息"];
                    this.control_str_human_set_msg = {
                      'position_human':tmp[0],
                    }
                    this.control_str_human_set_modal = true;
                  }
                }
              },
            )
          ]);
        }
      }
      this.control_str_human_show_record_table_columns[4]["tooltip"] = true;
    },
  },
  mounted() {
    this.account_id = this.$route.path.split("=")[1];
    this.draw_table_control_str_human()
  },
};
</script>

<style scoped>
.header-collapse {
  background-color: rgba(255, 255, 255, 0.2);
}
.panel-name {
  display: flex;
  font-size: 18px;
  color: #2b85e4;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.panel-content {
  font-size: 15px;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.demo-drawer-hearde {
  width: 100%;

  text-align: center;
  background: #fff;
}
</style>